'use strict';

var data = new function () {
    this.scriptsToLoad = [];
    this.scriptsLoaded = [];
    this.cssToLoad = [];
    this.cssLoaded = []; // Started to load
    this.cssLoadedFully = []; // Has rendered to DOM
    this.debug = false;

    this.doInitialiseSlickCarousels = function () {
        $('[data-slick]:not(.slick-initialized)').each(function () {
            if (data.isVisible($(this))) {
                var init = jQuery().slick;
                if (init) {
                    if ($(this).data('slickOptions')) {
                        var options = {};
                        if (typeof slickOptions == 'undefined') {
                            init = false;
                            setTimeout(function () {
                                data.doInitialiseSlickCarousels();
                            }, 100);
                        } else {
                            options = window['slickOptions'][$(this).data('slickOptions')]($(this));
                        }
                    }
                }
                if (init) {
                    $(this)
                        .on('init', function(event, slick) {
                            reality.setSlickInit($(this), event, slick);
                            reality.setLazyCarouselImages();
                        })
                        .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                            reality.setSlickBeforeChange($(this), event, slick, currentSlide, nextSlide);
                        })
                        .on('afterChange', function(event, slick, currentSlide, nextSlide) {
                            reality.setMediaBackground();
                            reality.setLazyCarouselImages();
                        })
                        .slick(options);
                }
            }
        });
    };
    this.doLoadScripts = function () {
        if (this.scriptsToLoad.length) {
            var scriptFileName = this.scriptsToLoad[0];
            data.scriptsToLoad.splice(0, 1);
            $.getScript(scriptFileName).done(function(scriptContents, textStatus) {
                if (typeof scriptContents != 'undefined' && !scriptContents.length) {
                    data.error('Loaded empty or invalid script', scriptFileName);
                }
                data.scriptsLoaded.push(scriptFileName);
                if (scriptFileName.indexOf('/js/vendor/slick.min.js') != -1) {
                    data.doInitialiseSlickCarousels();
                }
                if (scriptFileName.indexOf('zoom.min') != -1) {
                    $('.product__image-gallery-link').eq(0).trigger('mouseover'); // For the caption to work on first load
                }
                setTimeout(function () {
                    data.doLoadScripts();
                }, 10);
            })
            .fail(function () {
                data.error('Failed to load', scriptFileName);
                data.scriptsLoaded.push(scriptFileName);
                data.doLoadScripts();
            });
        }
    };
    this.getSlick = function (callObject, callMethod) {
        if (data.scriptsLoaded.indexOf(jsFiles.slick) == -1) {
            $.getScript(jsFiles.slick).done(function(scriptContents, textStatus) {
                window[callObject][callMethod]();
            });
        } else {
            window[callObject][callMethod]();
        }
    };
    this.doAddCss = function (cssFileName) {
        if (data.cssToLoad.indexOf(cssFileName) == -1 && data.cssLoaded.indexOf(cssFileName) == -1) {
            data.cssToLoad.splice(0, 1);
            $('head').append($('<link rel="stylesheet" type="text/css" href="' + cssFileName + '"/>').on('load', function () {
                $('[data-css="' + cssFileName + '"]').removeAttr('data-css');
                data.setScripts();
                data.cssLoadedFully.push(cssFileName);
            }));
            data.cssLoaded.push(cssFileName);
        } else if (data.cssLoadedFully.indexOf(cssFileName) != -1) {
            // Remove the data attributes even if already loaded otherwise elements remains hidden
            data.error('CSS [REMOVE]', cssFileName);
            $('[data-css="' + cssFileName + '"]').removeAttr('data-css');
        }
    };
    this.setScripts = function () {
        var load = false,
            scriptFileNames;
        $('[data-js]').each(function () {
            if (data.isVisible($(this))) {
                scriptFileNames = $(this).data('js').split(',');
                $.each(scriptFileNames, function (index, scriptFileName) {
                    scriptFileName = scriptFileName.trim();
                    if (data.scriptsToLoad.indexOf(scriptFileName) == -1 && data.scriptsLoaded.indexOf(scriptFileName) == -1) {
                        data.scriptsToLoad.push(scriptFileName)
                    }
                });
                load = true;
                $(this).removeAttr('data-js');
            }
        });
        if (load) data.doLoadScripts();
    };
    this.setCss = function () {
        $('[data-css]').each(function () {
            if (data.isVisible($(this)) && typeof $(this).data('css') != 'undefined') {
                data.doAddCss($(this).data('css'));
            }
        });
    };
    this.do = function (event, el, prevent_default) {
        if (prevent_default) {
            if (!$(el).is(':checkbox')) {
                event.preventDefault();
            }
        }
        if (typeof $(el).data(event.type) != 'undefined') {
            var action = $(el).data(event.type);
            if (!$(el).hasClass('disabled') && !$(el).prop('disabled')) {
                if (typeof action != 'undefined') {
                    if (action.indexOf(':') != -1) {
                        var objectName = action.split(':')[0];
                        action = action.split(':')[1];
                        if (typeof window[objectName] == 'undefined') {
                            data.error(objectName + ' is undefined');
                        } else if (typeof window[objectName][action] == 'undefined') {
                            data.error(objectName + ' has no function ' + action);
                        } else {
                            window[objectName][action](event, el);
                        }
                    }
                }
            }
        }
    };
    this.error = function (message, obj) {
        if (data.debug) {
            console.error(message, obj);
        }
    }
    this.isVisible = function ($element, threshold) {
        if (typeof threshold == 'undefined') threshold = 20;
        var docViewBottom = $(window).scrollTop() + $(window).height(),
            elemTop = $element.offset().top;
        if (elemTop > 0 && elemTop > threshold) {
            elemTop -= threshold;
        }
        if ($element.closest('.slick-slide').length && !$element.closest('.slick-slide').hasClass('slick-active')) {
            return false;
        }
        return elemTop > 0 && elemTop <= docViewBottom;
    };
};
jQuery.getScript = function( url, options ) {
  options = $.extend( options || {}, {
    dataType: 'script',
    cache: true,
    url: url
  });
  return jQuery.ajax(options);
};
$(function() {
    var types = {click: true, mouseover: true, change: true, keydown: false, keyup: false, submit: true};
    $.each(types, function (type, automaticallyPreventDefault) {
        $(document).on(type, '[data-' + type + ']', function (e) {
            if (!$(this).prop('disabled') && !$(this).attr('disabled')) {
                data.do(e, this, automaticallyPreventDefault);
            }
        });
    });
    $(document).on('click', 'a[rel*=external]', function(e) { e.preventDefault(); window.open($(this).attr('href')); });
    data.setScripts();
    data.setCss();
    $(window).on('resize scroll', function(){
        data.setScripts();
        data.setCss();
    });
    $(document).ajaxComplete(function() {
        data.setScripts();
        data.setCss();
    });
});
